import moment from 'moment';

export const convertToCurrency = (value) => {
  return value && value.toLocaleString('it-IT', { style: 'currency', currency: 'VND' });
};

export const convertToDiscount = (value) => {
  return value && `-${String(value)}%`;
};

export const convertToVNDate = (value) => {
  return moment(value).format("dddd, MMMM Do YYYY");
}

export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
